export enum EnabledStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}
